import { FC, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Input } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import useUpdateSettings from '../UI/Filter/hooks/useUpdateSettings'
import { Alert } from 'ui'

import { MFilters } from 'types/filterTypes'

type SaveSearchModalProps = {
  contentName: MFilters.ContentTypes
  savedOptions: MFilters.FilterTypes[MFilters.FilterKey]
}

const SaveSearchModal: FC<SaveSearchModalProps> = ({ contentName, savedOptions }) => {
  const dispatch = useDispatch()
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const presetKey: MFilters.PresetKey = `saved-search-${contentName}`
  const presets: MFilters.PresetTypes<typeof filterKey> = useMemo(() => {
    return settings[presetKey] || {}
  }, [settings, presetKey])

  const { savePresets } = useUpdateSettings(contentName)

  return (
    <BaseModal hideButtons title="manager.SAVED_PRESET_MODAL">
      <Formik
        validationSchema={Yup.object().shape({ name: Yup.string().required('manager.SAVED_PRESET_MODAL.NAME_REQUIRED') })}
        enableReinitialize={true}
        initialValues={{ name: '' }}
        onSubmit={values => {
          savePresets({ ...presets, [values.name]: savedOptions })
          dispatch(closeModal())
        }}
      >
        {({ dirty, isSubmitting, status, ...actions }) => {
          return (
            <Form resetForm={actions.resetForm} dirty={!!dirty && !isSubmitting}>
              {() => (
                <>
                  {/* Error message */}
                  <div className="form-group mb-4 mt-2">
                    <Alert variant={status?.type} onClose={() => actions.setStatus()} show={!!status?.msg}>
                      {status?.msg}
                    </Alert>
                    <Input module="manager.SAVED_PRESET_MODAL" name="name" required autoFocus />
                  </div>
                  {/* Submit & Cancel buttons */}
                  <Button className="btn btn-primary mr-2" type="submit" text="SAVE" />
                  <Button className="btn btn-outline-secondary" text="CLOSE" onClick={() => dispatch(closeModal())} />
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default SaveSearchModal
